import React, { useEffect, useState, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import { flatten, sumBy } from 'lodash';
import { DatePicker } from 'antd';
import moment from 'moment';
import Tooltip from '@/components/tooltip';
import Chart from '@/business-components/chart';
import Interval from '@/components/charts/interval';
import AmountTag from '@/business-components/amountTag';
import CustomEmpty from '@/business-components/CustomEmpty';
import styles from './index.module.scss';
import { defaultMonthVal } from 'pages/brand-contrast/[id]/index.page';
const cloutScale = {
  countTimeMonth: {
    type: 'cat',
    alias: '月份',
    sync: true,
    formatter(value) {
      return `${value}月`;
    },
  },
  increaseRateValue: {
    type: 'linear',
    min: 0,
    max: 100,
    tickCount: 2,
    nice: true,
    alias: '行业讨论热度环比',
    formatter(value) {
      return `${value}%`;
    },
  },
  discussValue: {
    type: 'linear',
    //   tickCount: 2,
    nice: true,
    alias: '行业讨论热度增长值',
    formatter(value) {
      return `${value}万`;
    },
  },
};

export default function GrowthSpace({ data, hasUnlock }) {
  // console.log(data);
  const [viewData, setViewData] = useState<any>(flatten(data?.map(item => item.list)));
  const [viewDataEmpty, setViewDataEmpty] = useState<boolean>(false);
  const [dateValue, setDateValue] = useState(defaultMonthVal);
  const [dateRange, setDateRange] = useState([]);

  const disabledDate2 = useCallback(
    (current): boolean => {
      return dateRange.every(item => item !== current.format('YYYY'));
      // (
      //   current.valueOf() < dateRange[0].valueOf() ||
      //   current.valueOf() > dateRange[dateRange?.length - 1 || 0].valueOf()
      // );
    },
    [dateRange]
  );

  const totalNum = useMemo(() => {
    return sumBy(viewData, 'value');
  }, [viewData]);
  useEffect(() => {
    const value: any = flatten(data?.map(item => item.list))?.filter(
      (item: any) => moment(item?.countTimeStr).year() === moment(dateValue).year()
    );
    setViewData(value);
    setViewDataEmpty(() => {
      return !value.length || value?.every(item => !item?.value);
    });
  }, [data, dateValue]);
  const handleDateChange = val => {
    setDateValue(val);
    setViewData(
      val
        ? flatten(data?.map(item => item.list))?.filter(
            (item: any) => moment(item?.countTimeStr).year() === moment(val).year()
          )
        : flatten(data?.map(item => item.list))
    );
  };
  useEffect(() => {
    const valueDateRange: any = [
      ...new Set(
        flatten(data?.map(item => item.list))
          ?.sort(
            (item: any, itemB: any) => moment(item?.countTimeStr).valueOf() - moment(itemB?.countTimeStr).valueOf()
          )
          .map((item: any) => item?.countTimeStr)
      ),
    ];
    setDateRange(valueDateRange);
    setDateValue(valueDateRange.length ? moment(valueDateRange[valueDateRange.length - 1], 'YYYY') : defaultMonthVal);
    // setDateValue(
    //   (flatten(data?.map(item => item.list))?.[flatten(data?.map(item => item.list))?.length - 1] as any)?.countTimeStr
    //     ? moment(
    //         (flatten(data?.map(item => item.list))?.[flatten(data?.map(item => item.list))?.length - 1] as any)
    //           ?.countTimeStr,
    //         'YYYY'
    //       )
    //     : defaultMonthVal
    // );
  }, [data, setViewData]);
  return (
    <div className={classNames('flex-row-wrap', 'flex-start-center', styles.growthSpace)}>
      <div className={styles.brandIndex}>
        <Chart
          title={
            <span className={styles.title}>
              行业消费规模
              <Tooltip
                title={
                  <>
                    <p>通过行业的消费规模反映行业增长空间与前景，数据已做脱敏处理。</p>
                    <p>数据来源：CBNData数据库</p>
                  </>
                }
                placement="right"
                style={{ marginRight: '33px' }}
              />
              {hasUnlock && (
                <DatePicker onChange={handleDateChange} picker="year" value={dateValue} disabledDate={disabledDate2} />
              )}
            </span>
          }
          titleFontSize={16}
          dateSubTitle={false}
          panelClassName={styles.card}
        >
          {/*{data?.map((item, index) => (*/}
          {/*  <AmountTag*/}
          {/*    title={`${item?.chName}（${item?.industryTrackName}）行业总消费规模指数`}*/}
          {/*    amount={item?.scaleValue}*/}
          {/*    key={index}*/}
          {/*  />*/}
          {/*))}*/}
          <>
            {hasUnlock ? (
              <>
                {totalNum != 0 && <AmountTag title={'行业当年消费规模'} amount={totalNum} />}
                {viewDataEmpty ? (
                  <CustomEmpty />
                ) : (
                  <Interval
                    height={333}
                    data={viewData || []}
                    scale={cloutScale}
                    size={10}
                    color={['chName']}
                    position={'dataTypeName*value'}
                    legend={{ position: 'top-left', padding: [14, 0, 19, 0] }}
                    tooltipNameKey={'industryTrackName'}
                  />
                )}
              </>
            ) : (
              <CustomEmpty text="已选择的品牌中有未解锁的品牌，请解锁后查看" />
            )}
          </>
        </Chart>
      </div>
    </div>
  );
}
